import React, { useContext } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { SandBoxContext } from '../SandboxModal';
import _ from 'lodash';
import ResponseBody from './ResponseBody';
import HeaderTable from './HeaderTable';
import ResponseLog from './ResponseLog';
import Placeholder from '../../placeholder/Placeholder';
import style from './SandboxResponse.module.css';
import clsx from 'clsx';

const SandboxResponse = () => {
  const { state, setState } = useContext(SandBoxContext);
  const { response } = state;

  return (
    <div>
      <h4 className={'font-weight-semi-bold'}>Response Preview</h4>

      {_.isNil(response) ? (
        <div className={'py-10'}>
          <Placeholder
            title={'Test Your Request'}
            icon={'info'}
            iconSize={75}
            titleSize={20}
            message={'Click Test Request Button to test your request against transaction.'}
          />
        </div>
      ) : (
        <Tabs className={clsx('mt-4', style.responseTabs)}>
          <Tab title={'Body'} eventKey="responseBody">
            <ResponseBody body={_.get(response, 'body')} />
          </Tab>
          <Tab title={`Headers (${_.size(response?.headers)})`} eventKey="responseHeaders">
            <HeaderTable headers={response?.headers} />
          </Tab>
          <Tab title={`Matching Log (${_.size(response?.matchingLog)})`} eventKey="matchingLog">
            <ResponseLog messages={response?.matchingLog} />
          </Tab>
        </Tabs>
      )}
    </div>
  );
};

export default SandboxResponse;
